module.exports = __webpack_public_path__ + "assets/icon_personnel_maintenance.13e27d35.svg";